import React from "react";
import UserProfile from "../../components/molecules/UserProfile/UserProfile";
import { useAuth0 } from "@auth0/auth0-react";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { NavLink } from "react-router-dom";
import InlineHelp from "../../components/molecules/InlineHelp/InlineHelp";
import AuthenticationButton from "../../auth0/AuthenticationButton/AuthenticationButton";

const NavContent = () => {
  const [expanded, setExpanded] = React.useState(null);

  const { user } = useAuth0();
  const enabledShare = user ? user[`${process.env.REACT_APP_AUTH0_KEY}/district`].enable_share : false;
  const enabledHealthBenefits = user ? user[`${process.env.REACT_APP_AUTH0_KEY}/district`].enable_hbenefits : false;
  const handleChange = (active) => (event, newExpanded) => {
    setExpanded(newExpanded ? active : false);
  };

  return (
    <>
      {user
        && ["api_group_admin", "api_super_admin", "api_user"].includes(user[`${process.env.REACT_APP_AUTH0_KEY}/role`])
        && (user[`${process.env.REACT_APP_AUTH0_KEY}/district`]['sessionType'] !== "No License") && (
          <>
            <div className={"profile-block"}>
              <UserProfile userName={user.nickname} userPic={user.picture} />
            </div>
            <MuiAccordion disableGutters
              expanded={expanded === "boards"}
              onChange={handleChange("boards")}
            >
              <MuiAccordionSummary
                expandIcon={<ArrowForwardIosSharpIcon sx={{ color: '#fff', fontSize: '1rem' }} />}
                aria-controls="boards-content"
                id="boards-summary"
              >
                Boards
              </MuiAccordionSummary>
              <ul className={"menu-wrapper"}>
                <li>
                  <NavLink
                    to="/insights"
                    className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                  >
                    District Insights
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/explorer"
                  >
                    District Explorer
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/election-history"
                  >
                    Election History
                  </NavLink>
                </li>
                {
                  enabledHealthBenefits &&
                  <>
                    <li>
                      <NavLink className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                        to="/health"
                      >
                        Benefits Toolkit
                      </NavLink>
                    </li>
                  </>
                }
                <li>
                  <NavLink className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/salary"
                  >
                    Salary Toolkit
                  </NavLink>
                </li>
                <li>
                  <NavLink className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/schedules"
                  >
                    Salary Schedules
                  </NavLink>
                </li>
                <li>
                  <NavLink className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/live-birth"
                  >
                    Enrollment Live Birth Index
                  </NavLink>
                </li>
                {
                  (user[`${process.env.REACT_APP_AUTH0_KEY}/role`] !== "api_user" || enabledShare) && (
                    <li>
                      <NavLink
                        className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                        to="/data-viewer"
                      >
                        Data Viewer
                      </NavLink>
                    </li>
                  )
                }
                {
                  /* Internal board: our own collection backlog, super admins only. */
                  user[`${process.env.REACT_APP_AUTH0_KEY}/role`] === "api_super_admin" && (
                    <li>
                      <NavLink
                        className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                        to="/harvest"
                      >
                        Harvest Cycle
                      </NavLink>
                    </li>
                  )
                }
                <li>
                  <NavLink
                    className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/glossary"
                  >
                    Glossary
                  </NavLink>
                </li>
              </ul>
            </MuiAccordion>
          </>
        )}
      {user
        && ["api_group_admin", "api_super_admin", "api_user"].includes(user[`${process.env.REACT_APP_AUTH0_KEY}/role`])
        && (user[`${process.env.REACT_APP_AUTH0_KEY}/district`]['sessionType'] !== "No License") && (
          enabledShare ? (
            <MuiAccordion disableGutters
              expanded={expanded === "saveShare"}
              onChange={handleChange("saveShare")}
            >
              <MuiAccordionSummary
                expandIcon={<ArrowForwardIosSharpIcon sx={{ color: '#fff', fontSize: '1rem' }} />}
                aria-controls="admin-content"
                id="admin-header"
              >
                Save & Share
              </MuiAccordionSummary>
              <ul className={"menu-wrapper"}>
                <li>
                  <NavLink
                    className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/custom-groups"
                  >
                    Custom Group Editor
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/custom-boards"
                  >
                    Custom Boards
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                    to="/crud/custom-groups"
                  >
                    Custom Groups
                  </NavLink>
                </li>
              </ul>
            </MuiAccordion>
          ) : (
            <>
              <NavLink
                className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                to="/custom-groups"
              >
                Custom Group Editor
              </NavLink>
              <NavLink
                className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                to="/crud/custom-groups"
              >
                Custom Groups
              </NavLink>
            </>
          ))}
      {user
        && ["api_super_admin", "api_group_admin"].includes(user[`${process.env.REACT_APP_AUTH0_KEY}/role`])
        && (user[`${process.env.REACT_APP_AUTH0_KEY}/district`]['sessionType'] !== "No License") &&
        (
          <MuiAccordion disableGutters
            expanded={expanded === "admin"}
            onChange={handleChange("admin")}
          >
            <MuiAccordionSummary
              expandIcon={<ArrowForwardIosSharpIcon sx={{ color: '#fff', fontSize: '1rem' }} />}
              aria-controls="admin-content"
              id="admin-header"
            >
              Admin
            </MuiAccordionSummary>
            <ul className={"menu-wrapper"}>
              {user && ["api_super_admin", "api_group_admin"].includes(user[`${process.env.REACT_APP_AUTH0_KEY}/role`]) &&
                (
                  <li>
                    <NavLink
                      className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                      to="/accounts"
                    >
                      Accounts
                    </NavLink>
                  </li>
                )}
              {user && ["api_group_admin", "api_super_admin"].includes(user[`${process.env.REACT_APP_AUTH0_KEY}/role`]) &&
                (
                  <>
                    <li>
                      <NavLink
                        className={({ isActive }) => isActive ? "MainNav__link selected" : 'MainNav__link'}
                        to="/users"
                      >
                        Search Users and Licenses
                      </NavLink>
                    </li>
                  </>
                )}
            </ul>
          </MuiAccordion>
        )}
      {user
        && ["api_group_admin", "api_super_admin", "api_user"].includes(user[`${process.env.REACT_APP_AUTH0_KEY}/role`])
        && (user[`${process.env.REACT_APP_AUTH0_KEY}/district`]['sessionType'] !== "No License") &&
        <InlineHelp />
      }
      <AuthenticationButton />
    </>
  )
}

export default NavContent;
